import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Input,
} from '@angular/core';
// global.d.ts
declare const bootstrap: any;

@Directive({
  selector: '[ncsTooltip]',
})
export class NcsTooltipDirective implements AfterViewInit {
  @Input('ncsTooltip') tooltipText!: string;
  tooltipElement: HTMLElement | null = null;
  bootstrapTooltipInstance: any = null; // Store Bootstrap tooltip instance

  constructor(private el: ElementRef) { }

  @HostListener('mouseenter') onMouseEnter() {
    this.createTooltip();
  }

@HostListener('mouseleave') onMouseLeave() {
  this.destroyTooltip();
}

@HostListener('click') onClick() {
  this.destroyTooltip1();
}

@HostListener('drop') onDrop() {
  this.destroyTooltip1();
}

@HostListener('dragend') onDragEnd() {
  this.destroyTooltip1();
}

  private createTooltip() {
    if (this.tooltipElement) return; // Avoid duplicate tooltips

    this.tooltipElement = document.createElement('div');
    this.tooltipElement.innerText = this.tooltipText;
    this.tooltipElement.className = 'tooltip';
    this.tooltipElement.style.position = 'absolute';
    this.tooltipElement.style.backgroundColor = '#333';
    this.tooltipElement.style.color = '#fff';
    this.tooltipElement.style.padding = '5px';
    this.tooltipElement.style.borderRadius = '5px';
    this.tooltipElement.style.zIndex = '1000'; // Ensure it’s above other elements

    // Position the tooltip
    const rect = this.el.nativeElement.getBoundingClientRect();
    this.tooltipElement.style.left = `${rect.left + window.scrollX}px`;
    this.tooltipElement.style.top = `${rect.top + window.scrollY - 30}px`; // Adjust position above the element

    document.body.appendChild(this.tooltipElement);
  }

private destroyTooltip() {

  if (this.tooltipElement) {
    document.body.removeChild(this.tooltipElement);
    this.tooltipElement = null; 
  }
}

private destroyTooltip1() {
  if (this.bootstrapTooltipInstance) {
    this.bootstrapTooltipInstance.dispose();
  }

  if (this.tooltipElement) {
    document.body.removeChild(this.tooltipElement);
    this.tooltipElement = null; // ✅ Reset immediately
  }
}

  ngAfterViewInit() {
    this.bootstrapTooltipInstance = new bootstrap.Tooltip(this.el.nativeElement);
  }
}
